import { ModalProps } from '@/types/shared'
import { formatPGDate } from '@/utils/function'
import dayjs from 'dayjs'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, FormItem } from 'vnetwork-ui'

interface DisableEmployeeModalProps extends ModalProps {
    employee_id: number
    employee_name?: string
    onConfirm: (data: { employee_id: number; off_date?: string }) => void
}

interface FormValues {
    off_date: string
}

const DisableEmployeeModal: React.FC<DisableEmployeeModalProps> = ({
    open,
    onClose,
    employee_id,
    employee_name,
    onConfirm,
}) => {
    const { t } = useTranslation()

    const { control, handleSubmit, watch } = useForm<FormValues>({
        defaultValues: {
            off_date: dayjs().format('YYYY-MM-DD'),
        },
    })

    const offDate = watch('off_date')

    const onSubmit = (data: FormValues) => {
        if (data.off_date) {
            onConfirm({
                employee_id,
                off_date: data?.off_date
                    ? (formatPGDate(
                          data.off_date,
                          'YYYY-MM-DDTHH:mm:ss'
                      ) as string)
                    : undefined,
            })
            onClose()
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('employee_disabled')}
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="p-4 space-y-4">
                    <div className="text-sm text-gray-600 mb-4">
                        {employee_name
                            ? `${t('employee_disabled_warning_with_name', { name: employee_name })}`
                            : t('employee_disabled_warning')}
                    </div>

                    <FormItem
                        control={control}
                        name="off_date"
                        type="datepicker"
                        label={t('off_date')}
                        placeholder={t('select_off_date')}
                    />

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <Button
                            variant="outlined"
                            onClick={onClose}
                            type="button"
                        >
                            {t('cancel')}
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            type="submit"
                            disabled={!offDate}
                        >
                            {t('employee_disabled')}
                        </Button>
                    </div>
                </div>
            </form>
        </Dialog>
    )
}

export default DisableEmployeeModal
